import React from "react";
import { useLocation, Link } from "react-router-dom";

export default function PaymentSuccess() {
  const query = new URLSearchParams(useLocation().search);
  const message = query.get("msg") || "Payment Successful 🎉";

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md text-center">
        <div className="mb-4 p-3 rounded bg-green-100 text-green-700">
          {message}
        </div>
        <h2 className="text-2xl font-bold">Thank You!</h2>
        <p className="text-gray-600 mt-2">
          Your membership fee has been received. Your membership details will be send on your registered number soon.
        </p>
        <Link
          to="/members"
          className="mt-6 inline-block px-6 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700"
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
}
